export const LocalStorageKey = {
	users: 'user',
	token: 'token',
	loginInfo: 'loginInfo',
	proInvestorCount: 'proCount',
	notificationCount: 'notifyCount',
	loadAllCollection: 'loadAllCollection',
	investorsCollections: 'investorsCollections',
	borrowersCollections: 'borrowersCollections',
	borrowerCreditCollections: "borrowerCreditCollections",
	region: 'region',
	systemSettings: 'systemSettings',
	notificationType: 'notificationType',
	chatConversation: 'chatConversation',
	chatPanel: 'chatPanel',
};
